import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { RecuperarSenhaService } from '../../../../shared/services/auth/recuperar-senha/recuperar-senha.service';

import { strings } from './../../../../../environments/environment';

import * as md5 from 'blueimp-md5';

@Component({
  selector: 'app-criar-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss']
})
export class RedefinirSenhaComponent implements OnInit {
  public id = '';
  public email = '';

  public apiError = '';
  public form: FormGroup = null;

  public passwordType = false;
  public confirmPasswordType = false;

  public code = '';
  public success = false;
  public responseMessage = '';

  constructor(
    private fb: FormBuilder,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private recuperarSenhaService: RecuperarSenhaService
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'] ? this.route.snapshot.params['id'] : '';
    this.code = this.route.snapshot.params['code'] ? this.route.snapshot.params['code'] : '';

    this.form = this.fb.group({
      password: [null, [Validators.required]],
      confirmPassword: [null, [Validators.required]]
    }, { validator: this.matchPassword });
  }

  matchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;
    if (password !== confirmPassword) {
      AC.get('confirmPassword').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  keyUpPassword() {
    this.passwordType = true;
  }

  keyUpConfirmPassword() {
    this.confirmPasswordType = true;
  }

  showErrors() {
    this.passwordType = true;
    this.confirmPasswordType = true;
  }

  sendResetPassword() {
    this.enableLoading();
    this.success = false;
    const data = {
      Email: this.email,
      Code: this.code,
      Password: md5(this.email + this.form.controls.password.value),
      ConfirmPassword: md5(this.email + this.form.controls.confirmPassword.value),
      UserId: this.id
    };
    this.recuperarSenhaService.redefinirSenha(data)
      .subscribe(() => {
        this.disableLoading();
        this.responseMessage = 'Sua senha foi redefinida com sucesso!';
        this.success = true;
      }, (err) => {
        this.success = false;
        this.apiError = 'Não foi possível redefinir a senha. Tente novamente mais tarde.';
        this.disableLoading();
      });
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/components/redefinir-senha/redefinir-senha.component.ts